import { render, staticRenderFns } from "./float-button.vue?vue&type=template&id=13643544&"
import script from "./float-button.vue?vue&type=script&lang=js&"
export * from "./float-button.vue?vue&type=script&lang=js&"
import style0 from "./float-button.vue?vue&type=style&index=0&id=13643544&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports